var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeforemax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5934 15.6896L18.5934 9.30962C18.5934 8.00295 17.1734 7.18295 16.0401 7.83629L13.2734 9.42962L10.5067 11.0296C9.3734 11.683 9.3734 13.3163 10.5067 13.9696L13.2734 15.5696L16.0401 17.163C17.1734 17.8163 18.5934 17.003 18.5934 15.6896Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15662 7.88012C7.42995 7.88012 7.65662 8.10679 7.65662 8.38012L7.65662 16.6201C7.65662 16.8935 7.42995 17.1201 7.15662 17.1201C6.88328 17.1201 6.65662 16.8935 6.65662 16.6201L6.65662 8.38012C6.65662 8.10679 6.87662 7.88012 7.15662 7.88012Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforemax);
export default __webpack_public_path__ + "static/media/beforemax.7e5d37558e490f4898e406c120de6041.svg";
export { ForwardRef as ReactComponent };